export enum FileThumbnailDisplayType {
  Folder = 'folder',
  Unknown = 'unknown',
  Image = 'image',
  Audio = 'audio',
  Document = 'document',
  Video = 'video',
  Sheet = 'sheet',
  Markdown = 'markdown',
  Text = 'text',
  Archive = 'archive',
  Html = 'html',
}
